import React from 'react';
import Title from './../UI/Title';
import Contact from './../UI/Contact';

const ContactUs = () => (
  <div>
    <Title>צרו קשר</Title>
    <p className="mb-12 lg:mb-20"></p>
    <Contact size="medium" />
  </div>
)

export default ContactUs;
